import MountPointsClass from 'shared/utils/mountPoints'

import useShopAndRuntimeConfig from './useShopAndRuntimeConfig'

const useMountPoints = () => {
  const {
    publicRuntimeConfig: {
      publicConfig: { mountPoints, tenant, language },
      pageProperties: { coreShopEnvironment, featureToggles },
    },
  } = useShopAndRuntimeConfig()

  return new MountPointsClass({
    mountPoints,
    tenant,
    language,
    coreShopEnvironment,
    featureToggles,
  })
}

export default useMountPoints
